import React, { useEffect, useRef, useState } from 'react'
import Sidebar from '../components/Sidebar'
import Header from '../components/Header'
import { Autocomplete, Avatar, Box, Button, Card, CircularProgress, Container, Divider, Fab, Grid, IconButton, InputAdornment, List, ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, Modal, Paper, Stack, Tab, Tabs, TextField, Tooltip, Typography } from '@mui/material'


// Iconos
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import SearchIcon from '@mui/icons-material/Search';
import SendIcon from '@mui/icons-material/Send';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import ShareIcon from '@mui/icons-material/Share';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import PartyModeIcon from '@mui/icons-material/PartyMode';
import ShareRoundedIcon from '@mui/icons-material/ShareRounded';
import BlockIcon from '@mui/icons-material/Block';
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import SettingsIcon from '@mui/icons-material/Settings';
import GridViewIcon from '@mui/icons-material/GridView';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import FavoriteIcon from '@mui/icons-material/Favorite';
import CommentIcon from '@mui/icons-material/Comment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import UndoIcon from '@mui/icons-material/Undo';
import SidebarResponsive from '../components/SidebarResponsive';
import { connect } from 'react-redux';
import axios from 'axios';
import store from '../store';
import { LOGIN_USER_action } from '../store/actions/userAction';
import { useNavigate } from 'react-router-dom';
import CryptoJS from "crypto-js";
import imageCompression from 'browser-image-compression';
import FloatingActionButton from '../components/FloatingActionButton';
import BottomNavigationBar from '../components/BottomNavigation';
import { EVENTDETAILS_action } from '../store/actions/eventDetailsAction';

const mapStateToProps = (state) => {
  return {
    page: state.pageReducer.pageName,
    token: state.tokenReducer.token,
    user: state.userReducer
  }
}



const Perfil = (props) => {
  const [isLargeScreen, setIsLargeScreen] = useState(null); // Mide el tamaño de la pantalla para hacer el diseño responsive
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false); // Estado para la pantalla de carga
  const [loadingFriends, setLoadingFriends] = useState(false);
  const [loadingPendingFriends, setLoadingPendingFriends] = useState(false);
  const [loadingBlockedFriends, setLoadingBlockedFriends] = useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [openModalUpdatedUser, setOpenModalUpdatedUser] = React.useState(false);
  const [openModalAddFriends, setOpenModalAddFriends] = React.useState(false);
  const [openModalPendingFriends, setOpenModalPendingFriends] = React.useState(false);
  const [openModalConfirmarDelete, setOpenModalConfirmarDelete] = React.useState(false);
  const [openModalConfirmarBlockFriend, setOpenModalConfirmarBlockFriend] = React.useState(false);
  const [openModalConfirmarDeleteFriend, setOpenModalConfirmarDeleteFriend] = React.useState(false);
  const [openModalBlockedUsers, setOpenModalBlockedUsers] = React.useState(false);
  const [openModalConfirmarCancelFriend, setOpenModalConfirmarCancelFriend] = React.useState(false);
  const [openModalConfirmarDeletePost, setOpenModalConfirmarDeletePost] = React.useState(false);
  const [openShareModal, setOpenShareModal] = useState(false);
  const [postToDelete, setPostToDelete] = useState(null);
  const [anchorEl, setAnchorEl] = useState(false);
  const [selectedFriendList, setSelectedFriendList] = useState();

  const [tabValue, setTabValue] = useState(0);
  // const [posts, setPosts] = useState([
  //   { id: 1, image: 'https://source.unsplash.com/random/300x300?event=1', likes: 120, comments: 14 },
  //   { id: 2, image: 'https://source.unsplash.com/random/300x300?event=2', likes: 85, comments: 7 },
  //   { id: 3, image: 'https://source.unsplash.com/random/300x300?event=3', likes: 210, comments: 23 },
  //   { id: 4, image: 'https://source.unsplash.com/random/300x300?event=4', likes: 45, comments: 3 },
  //   { id: 5, image: 'https://source.unsplash.com/random/300x300?event=5', likes: 67, comments: 9 },
  //   { id: 6, image: 'https://source.unsplash.com/random/300x300?event=6', likes: 132, comments: 18 },
  // ]);

  const [posts, setPosts] = useState([]);

  let [publicKey, setPublicKey] = useState('');
  let statePublicKey = '';
  let [privateKey, setPrivateKey] = useState('');
  let statePrivateKey = '';

  let [eventLink, setEventLink] = useState('');
  let [hidePass, setHidePass] = useState(false)
  let [subscriptedToNotifications, setSubscriptedToNotifications] = useState(false)
  let [allowEdition, setAllowEdition] = useState(false)

  const [avatarPreview, setAvatarPreview] = useState(null);
  const [avatarPreviewBlob, setAvatarPreviewBlob] = useState('');
  const fileInputRef = useRef(null);

  const [userName, setUserName] = useState(props.user.nombre)
  const [userPhone, setUserPhone] = useState(props.user.phone)
  const [userEmail, setUserEmail] = useState(props.user.email)
  const [userAvatar, setUserAvatar] = useState("")
  const [passwordConfirmation, setPasswordConfirmation] = useState("")


  const [userPassword, setUserPassword] = useState(props.user.password)

  // Listado de amistades actuales
  let [friends, setFriends] = useState([
    // { name: "Ali Connors" },
    // { name: "Joaquin Vitar" },
    // { name: "Elias Brondo" },
    // { name: "Facundo Mecodangelo" },
    // { name: "Horacio Falco" },
    // { name: "Silvana Bianchini" }
  ]);
  let [pendingFriends, setPendingFriends] = useState([]);
  let [blockedFriends, setBlockedFriends] = useState([]);

  // Listado de usuarios registrados
  const [availableUsers, setAvailableUsers] = useState([]);
  let [msgError, setMsgError] = useState("")


  let [searchFriends, setSearchFriends] = useState('')

  let [idNewFriend, setIdNewFriend] = useState(0) // Aca se almacenaran los datos del usuario a invitar

  let [selectedFriendToAdd, setSelectedFriendToAdd] = useState(null) // Aca se almacenaran los datos del usuario a invitar

  const filteredFriends = friends.filter(friend =>
    friend.nameUser.toLowerCase().includes(searchFriends.toLowerCase())
  );

  let [idUserToDelete, setIdUserToDelete] = useState(0)
  let [idUserToBlock, setIdUserToBlock] = useState(0)
  let [idUndoBlockedUser, setIdUndoBlockedUser] = useState(0)
  let [idFriendToCancel, setIdFriendToCancel] = useState(0)

  const [changedValue, setChangedValue] = useState(false)

  const handleDeletePost = (postId) => {
    setPostToDelete(postId);
    setOpenModalConfirmarDeletePost(true);
  };

  const confirmDeletePost = () => {
    console.log("postToDelete")
    console.log(postToDelete)
    if (!postToDelete) return;

    const headers = 'content-type: application/json; charset=utf-8';
    const data = { data: postToDelete };

    const jsonData = JSON.stringify(data);
    const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

    axios.post('https://socializeapi.azurewebsites.net/api/DeleteEvent', { data: data_encripted }, { headers })
      .then(response => {
        setPosts(posts.filter(post => post.id !== postToDelete));
        setOpenModalConfirmarDeletePost(false);
        setPostToDelete(null);
        GetEvents();
      })
      .catch(error => {
        console.log(`Error eliminando post: ${error}`);
      });
  };


  async function updateProfile() {
    setLoading(true)

    try {
      const headers = 'content-type: application/json; charset=utf-8'
      const encryptionKey = "EsteEsUnEjemploDeClaveDe32Caracteres!";

      const data = {
        id: props.user.id,
        email: userEmail,
        userName: userName,
        phone: userPhone
      }


      const jsonData = JSON.stringify(data);
      const encripted_data = CryptoJS.AES.encrypt(jsonData, encryptionKey).toString();


      await axios.put('https://socializeapi.azurewebsites.net/api/UpdateUser', { data: encripted_data }, { headers })
        .then(response => {
          getUserInfo()
          setOpenModalUpdatedUser(true)
        })
        .catch(error => {
          console.log(`Error obteniendo datos: ${error}`);
        });

    } catch (error) {
      console.log(`Error obteniendo datos: ${error}`);
    } finally {
      uploadAvatar()
      setAllowEdition(false)
      setLoading(false); // Ocultar pantalla de carga
    }
  }


  async function getUserInfo() {

    const token = localStorage.getItem('jwt_token');

    const data = {
      "UserID": props.user.id,
    }
    const jsonData = JSON.stringify(data);
    const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

    const headers = 'content-type: application/json; charset=utf-8'

    await axios.post('https://socializeapi.azurewebsites.net/api/GetUser', { data: data_encripted }, {
      headers
    })
      .then(response => {

        console.log(JSON.stringify("perfil"))
        console.log((JSON.stringify(response.data)).avatar)
        store.dispatch(LOGIN_USER_action(response.data))
        localStorage.setItem('userData', JSON.stringify(response.data))
      })
      .catch(error => {
        console.log(`Error obteniendo datos: ${error}`);
      });
  }

  const getAvatar = () => {
    const data = {
      "UserID": props.user.id,
    }
    const jsonData = JSON.stringify(data);
    const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

    const headers = 'content-type: application/json; charset=utf-8'

    axios.post('https://socializeapi.azurewebsites.net/api/GetAvatar', { data: data_encripted }, {
      headers: { 'Content-Type': 'application/json; charset=utf-8' }
    })
      .then(response => {
        console.log("response")
        console.log(response)
        const imageUrl = response.data.avatar;

        setUserAvatar(imageUrl + "?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D")
        var user = localStorage.getItem('userData')

        var parsedUser = JSON.parse(user);
        parsedUser.avatar = imageUrl

        console.log(JSON.stringify("perfil 2"))
        console.log((JSON.stringify(parsedUser)).avatar)
        localStorage.setItem('userData', JSON.stringify(parsedUser))
      })
      .catch(error => {
        console.log(`Error obteniendo datos: ${error}`);
      });
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };


  async function suscriptionState(action) {
    const userAgent = navigator.userAgent;
    setLoading(true);

    if (action == "activar") {
      await obtenerVAPID();

      const registration = await navigator.serviceWorker.register('/service-worker.js');

      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        console.error('Permission for notifications was denied.');
        setOpenModal(true);
        setLoading(false);
        return;
      }

      try {
        const userAgent = navigator.userAgent;

        // Verifica si el usuario tiene una suscripcion activa en algun dispositivo
        const subscription = await registration.pushManager.getSubscription();
        if (subscription) { // si el usuario ya tiene una suscripcion activa entra aca

          // Cancela la suscripción activa
          await subscription.unsubscribe();


          const data = {
            UserId: props.user.id,
            Device: ""
          }

          const jsonData = JSON.stringify(data);
          const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

          const headers = 'content-type: application/json; charset=utf-8'
          try {
            const response = await axios.post('https://socializeapi.azurewebsites.net/api/unsubscribetonotifications', { data: data_encripted }, { headers });


          } catch (error) {
            console.log(`Error obteniendo datos: ${error}`);
          }



          console.log('Suscripción de notificaciones cancelada exitosamente.');
        } else {
          console.log('No hay ninguna suscripción activa para cancelar.');
        }

        const addsubscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(statePublicKey)
        });

        console.log("addsubscription object:", JSON.stringify(addsubscription));


        // Validar que `keys` esté definido antes de usarlo
        if (!addsubscription.getKey('p256dh') || !addsubscription.getKey('auth')) {
          throw new Error("Keys are undefined in the subscription object");
        }

        const data = {
          Endpoint: addsubscription.endpoint,
          P256dh: addsubscription.getKey('p256dh'),
          Auth: addsubscription.getKey('auth'),
          UserId: props.user.id
        }

        const jsonData = JSON.stringify(data);
        const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

        // Enviar la suscripción al backend
        await axios.post(`https://socializeapi.azurewebsites.net/api/register-push?userId=${props.user.id}`, {
          Endpoint: addsubscription.endpoint,
          // Keys: {
          //   p256dh: addsubscription.getKey('p256dh'),
          //   auth: addsubscription.getKey('auth')
          // }
          Keys: {
            p256dh: btoa(String.fromCharCode(...new Uint8Array(addsubscription.getKey('p256dh')))),
            auth: btoa(String.fromCharCode(...new Uint8Array(addsubscription.getKey('auth'))))
          },
          PublicKey: statePublicKey,
          PrivateKey: statePrivateKey,
          UserAgent: userAgent

        });
      } catch (error) {
        console.error('Failed to subscribe:', error.message || error);
      } finally {
        setLoading(false); // Ocultar pantalla de carga
        setSubscriptedToNotifications(true);
      }




    }

    if (action == "desactivar") {
      console.log("entro desactivar")


      const registration = await navigator.serviceWorker.register('/service-worker.js');

      // Obtén la suscripción activa
      // const subscription = await registration.pushManager.getSubscription();

      // Si ya hay una suscripción, desuscribirse
      // await subscription.unsubscribe();

      disableNotifications();
      console.log('Successfully unsubscribed from the existing subscription.');

      const data = {
        UserId: props.user.id,
        Device: userAgent
      }

      const jsonData = JSON.stringify(data);
      const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

      const headers = 'content-type: application/json; charset=utf-8'
      try {
        const response = await axios.post('https://socializeapi.azurewebsites.net/api/unsubscribetonotifications', { data: data_encripted }, { headers });


      } catch (error) {
        console.log(`Error obteniendo datos: ${error}`);
      } finally {
        setLoading(false); // Ocultar pantalla de carga
        setSubscriptedToNotifications(false)
      }
      // if (Notification.permission === "granted") {



      // }
    }


  }

  async function obtenerVAPID() {
    const headers = 'content-type: application/json; charset=utf-8'

    await axios.get(`https://socializeapi.azurewebsites.net/api/getvapid`, null, { headers })
      .then(response => {
        if (response.data !== null) {
          setPublicKey(response.data.keys.publicKey)
          statePublicKey = response.data.keys.publicKey
          setPrivateKey(response.data.keys.privateKey)
          statePrivateKey = response.data.keys.privateKey
        }

      })
      .catch(error => {
        console.log(`Error obteniendo datos: ${error}`);
      });
  }


  async function disableNotifications() {
    try {
      // Obtén el registro del service worker
      const registration = await navigator.serviceWorker.getRegistration();
      if (!registration) {
        console.log('No se encontró un service worker registrado.');
        return;
      }

      // Obtén la suscripción activa
      const subscription = await registration.pushManager.getSubscription();
      if (subscription) {
        // Cancela la suscripción activa
        await subscription.unsubscribe();
        console.log('Suscripción de notificaciones cancelada exitosamente.');
      } else {
        console.log('No hay ninguna suscripción activa para cancelar.');
      }

      // Informar al usuario cómo revocar permisos
      // alert('Las notificaciones han sido desactivadas. Para revocar completamente los permisos, ve a la configuración del navegador.');
    } catch (error) {
      console.error('Error al desactivar las notificaciones:', error);
    }
  }

  function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/');

    const rawData = window.atob(base64);
    return new Uint8Array([...rawData].map(char => char.charCodeAt(0)));
  }

  function getUsers() {
    const token = localStorage.getItem('jwt_token');

    var data = {
      loguedUser: props.user.id,
      usersIDs: ""
    }

    const jsonData = JSON.stringify(data);
    const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

    const headers = 'content-type: application/json; charset=utf-8'
    axios.post(`https://socializeapi.azurewebsites.net/api/GetUsers`, { data: data_encripted }, {
      headers
    })
      .then(response => {
        let decripted_response = decryptData(response.data)
        let convertedToArray = JSON.parse(decripted_response)


        setAvailableUsers(convertedToArray)
      })
      .catch(error => {
        console.log(`Error obteniendo datos: ${error}`);
        if (error == "AxiosError: Request failed with status code 401") {
          navigate("/login")
          alert("Sesión caducada!")
        }
      })
  }

  function deleteUser() {
    if (passwordConfirmation) {

      try {
        setLoading(true); // Ocultar pantalla de carga

        const headers = 'content-type: application/json; charset=utf-8'
        const userID = parseInt(props.user.id);
        const token = localStorage.getItem('jwt_token');

        axios.delete(`https://socializeapi.azurewebsites.net/api/DeleteUser?userID=${userID}&pass=${passwordConfirmation}`, { headers })
          .then(response => {
            if (response.data == "La contraseña es incorrecta.") {
              setMsgError("La contraseña es incorrecta.")
              return;
            } else {
              setOpenModalConfirmarDelete(false);
              navigate("/login")
            }
          })
          .catch(error => {
            console.log(`Error obteniendo datos: ${error}`);
            // if (error.response && error.response.status === 401) {
            //   navigate("/login");
            //   alert("Sesión caducada!");
            // }
          });

      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false); // Ocultar pantalla de carga
      }
    } else {
      setMsgError("Debes ingresar tu contraseña.")
    }

  }

  async function getFriends() {
    try {
      setLoadingFriends(true);

      const token = localStorage.getItem('jwt_token');

      var data = {
        userID_1: JSON.parse(localStorage.getItem('userData')).userID
      }

      // const jsonData = JSON.stringify(data);
      // const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

      const headers = 'content-type: application/json; charset=utf-8'
      await axios.post(`https://socializeapi.azurewebsites.net/api/getfriends`, data, {
        headers
      })
        .then(response => {
          // let decripted_response = decryptData(response.data)
          // let convertedToArray = JSON.parse(decripted_response)
          // setAvailableUsers(response.data)
          console.log("amigos")
          console.log(response.data)
          setFriends(response.data)
        })
        .catch(error => {
          console.log(`Error obteniendo datos: ${error}`);
          if (error == "AxiosError: Request failed with status code 401") {
            navigate("/login")
            alert("Sesión caducada!")
          }
        })
    } catch (error) {
      console.log("Error: " + error)
    } finally {
      setLoadingFriends(false);
    }

  }

  async function getPendingFriends() {
    try {
      setLoadingPendingFriends(true);


      const headers = 'content-type: application/json; charset=utf-8'
      const token = localStorage.getItem('jwt_token');

      var data = {
        userID_1: JSON.parse(localStorage.getItem('userData')).userID,
        userID_2: -1
      }

      const jsonData = JSON.stringify(data);
      const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

      // const headers = 'content-type: application/json; charset=utf-8'
      await axios.post(`https://socializeapi.azurewebsites.net/api/getpendingfriends`, data, {
        headers
      })
        .then(response => {
          // let decripted_response = decryptData(response.data)
          // let convertedToArray = JSON.parse(decripted_response)
          console.log("amigos pendientes")
          console.log(response.data)

          setPendingFriends(response.data)
        })
        .catch(error => {
          console.log(`Error obteniendo datos: ${error}`);
        })
    } catch (error) {
      console.log("Error: " + error)
    } finally {
      setLoadingPendingFriends(false);
    }

  }

  async function getBlockedFriends() {
    try {
      setLoadingBlockedFriends(true);

      const token = localStorage.getItem('jwt_token');

      var data = {
        userID_1: JSON.parse(localStorage.getItem('userData')).userID
      }

      // const jsonData = JSON.stringify(data);
      // const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

      const headers = 'content-type: application/json; charset=utf-8'

      axios.post(`https://socializeapi.azurewebsites.net/api/getblockedfriends`, data, {
        headers
      })
        .then(response => {
          // let decripted_response = decryptData(response.data)
          // let convertedToArray = JSON.parse(decripted_response)

          setBlockedFriends(response.data)
        })
        .catch(error => {
          console.log(`Error obteniendo datos: ${error}`);
          if (error == "AxiosError: Request failed with status code 401") {
            navigate("/login")
            alert("Sesión caducada!")
          }
        })
    } catch (error) {
      console.log("Error: " + error)
    } finally {
      setLoadingBlockedFriends(false);
    }

  }

  function sendFriendshipRequest() {
    const headers = 'content-type: application/json; charset=utf-8'
    const token = localStorage.getItem('jwt_token');

    var data = {
      userID_1: JSON.parse(localStorage.getItem('userData')).userID,
      userID_2: selectedFriendToAdd
    }

    const jsonData = JSON.stringify(data);
    const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

    axios.post(`https://socializeapi.azurewebsites.net/api/friendshipreq`, data, {
      headers
    })
      .then(response => {
        enviarnotificacionFriendRequest(selectedFriendToAdd);
      })
      .catch(error => {
        console.log(`Error obteniendo datos: ${error}`);
        if (error == "AxiosError: Request failed with status code 401") {
          navigate("/login")
          alert("Sesión caducada!")
        }
      })
  }

  async function addFriend(friendID) {
    const headers = 'content-type: application/json; charset=utf-8'
    const token = localStorage.getItem('jwt_token');

    var data = {
      userID_1: friendID, // userID_1 es quien envio la peticion de amistad
      userID_2: JSON.parse(localStorage.getItem('userData')).userID // userID_2 es quien recibio la peticion de amistad
    }


    // const jsonData = JSON.stringify(data);
    // const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

    await axios.post(`https://socializeapi.azurewebsites.net/api/addfriend`, data, {
      headers
    })
      .then(response => {
        console.log(response.data)
        enviarnotificacionAddedFriend(friendID)
      })
      .catch(error => {
        console.log(`Error obteniendo datos: ${error}`);
      })


    await getPendingFriends()
    await getFriends();
  }

  async function blockUser() {
    const headers = 'content-type: application/json; charset=utf-8'
    const token = localStorage.getItem('jwt_token');

    var data = {
      userID_1: JSON.parse(localStorage.getItem('userData')).userID,
      userID_2: idUserToBlock
    }

    const jsonData = JSON.stringify(data);
    const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

    console.log("blockUser")
    await axios.post(`https://socializeapi.azurewebsites.net/api/blockUser`, data, {
      headers
    })
      .then(response => {
        console.log(response.data)
      })
      .catch(error => {
        console.log(`Error obteniendo datos: ${error}`);
        if (error == "AxiosError: Request failed with status code 401") {
          navigate("/login")
          alert("Sesión caducada!")
        }
      })
  }

  async function undoBlockedUser(id) {
    try {
      const headers = 'content-type: application/json; charset=utf-8'
      const token = localStorage.getItem('jwt_token');

      var data = {
        userID_1: JSON.parse(localStorage.getItem('userData')).userID,
        userID_2: id
      }

      // const jsonData = JSON.stringify(data);
      // const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

      console.log("undoBlockedUser")
      console.log(data)
      await axios.post(`https://socializeapi.azurewebsites.net/api/undoblockedUser`, data, {
        headers
      })
        .then(response => {
        })
        .catch(error => {
          console.log(`Error obteniendo datos: ${error}`);
          if (error == "AxiosError: Request failed with status code 401") {
            navigate("/login")
            alert("Sesión caducada!")
          }
        })
    } catch (error) {

    } finally {
      await getBlockedFriends();
      await getUsers();
    }

  }

  async function cancelFriend(id) {
    const headers = 'content-type: application/json; charset=utf-8'
    try {
      const token = localStorage.getItem('jwt_token');

      var data = {
        userID_1: JSON.parse(localStorage.getItem('userData')).userID,
        userID_2: id
      }

      // const jsonData = JSON.stringify(data);
      // const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

      console.log("cancelFriend")
      console.log(id)
      console.log(idUserToDelete)
      await axios.post(`https://socializeapi.azurewebsites.net/api/cancelfriend`, data, {
        headers
      })
        .then(response => {
        })
        .catch(error => {
          console.log(`Error obteniendo datos: ${error}`);
          if (error == "AxiosError: Request failed with status code 401") {
            navigate("/login")
            alert("Sesión caducada!")
          }
        })
    } catch (error) {

    } finally {
      await getUsers();
      await getFriends();
      await getPendingFriends();
      setOpenModalConfirmarDeleteFriend(false);
    }

  }

  function selectedFriend(event, value) {
    if (value !== null) {

      setSelectedFriendToAdd(value.UserID)
    }
  }

  async function GetEvents() {


    const token = localStorage.getItem('jwt_token');

    let data;
    let userData;

    const userDataString = localStorage.getItem('userData'); // Obtiene la cadena JSON de localStorage
    userData = JSON.parse(userDataString); // Convierte la cadena JSON a un objeto




    var userID = userData.userID
    data = {
      title: props.searchEventTitle,
      // creatorName: props.user.nombre,
      eventPrivacity: '',
      // creatorID: contenedorSEC,
      userID: userID,
      creatorID: 0


    }

    const jsonData = JSON.stringify(data);

    const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

    const headers = 'content-type: application/json; charset=utf-8'
    // withCredentials: true

    // let headers = { Authorization: `Bearer ${props.token}` };

    await axios.post(`https://socializeapi.azurewebsites.net/api/GetEvents`, data, {
      headers
    })
      .then(response => {
        // let decripted_response = decryptData(response.data)


        const mainEvents = JSON.parse(localStorage.getItem('userData')).userID ? response.data.filter(item => userData.userID == item.creatorId) : [];

        // const sortedCombinedEvents = uniqueCombinedEvents.sort((a, b) => new Date(a.eventDate) - new Date(b.eventDate));
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);

        // Filter events within the last week and sort them
        const sortedCombinedEvents = mainEvents
          .sort((a, b) => {
            // Create Date objects combining eventDate and startHour
            const dateA = new Date(`${a.startDay.split("T")[0]}T${a.startHour}`);
            const dateB = new Date(`${b.startDay.split("T")[0]}T${b.startHour}`);

            // Compare combined dates and times
            return dateA - dateB;
          });

        let eventList = sortedCombinedEvents

        console.log("eventList")
        console.log(response.data)
        console.log(eventList)

        setPosts(eventList)




      })
      .catch(error => {
        console.log(`Error obteniendo los eventos: ${error}`);
      })
  }

  async function procesoDeBloqueo(item) {
    setOpenModalConfirmarBlockFriend(false);
    await blockUser();
    await getFriends()
    await getBlockedFriends();
  }

  async function procesoDeDesbloqueo(item) {
    setOpenModalBlockedUsers(true);
    // setIdUndoBlockedUser(item); 
    // await undoBlockedUser(); 

    await getBlockedFriends();
  }

  async function enviarnotificacionFriendRequest(friendId) {


    const headers = 'content-type: application/json; charset=utf-8'
    await obtenerVAPID()

    const data = {
      "privateKey": statePrivateKey,
      "publicKey": statePublicKey,
      "userAgent": navigator.userAgent,
      "friendID": friendId,
      "userID": JSON.parse(localStorage.getItem('userData')).userID,
      "action": "friendrequest"
    }

    const jsonData = JSON.stringify(data);
    const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();



    await axios.post('https://socializeapi.azurewebsites.net/api/send-notification', { data: data_encripted }, {
      headers
    })
      .then(response => {
      })
      .catch(error => {
        console.log(`Error obteniendo datos: ${error}`);
        if (error == "AxiosError: Request failed with status code 401") {
          navigate("/login")
          alert("Sesión caducada!")
        }
      });
  }

  async function enviarnotificacionAddedFriend(friendId) {


    const headers = 'content-type: application/json; charset=utf-8'
    await obtenerVAPID()

    const data = {
      "privateKey": statePrivateKey,
      "publicKey": statePublicKey,
      "userAgent": navigator.userAgent,
      "friendID": friendId,
      "userID": JSON.parse(localStorage.getItem('userData')).userID,
      "action": "addedfriend"
    }

    const jsonData = JSON.stringify(data);
    const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();



    await axios.post('https://socializeapi.azurewebsites.net/api/send-notification', { data: data_encripted }, {
      headers
    })
      .then(response => {
      })
      .catch(error => {
        console.log(`Error obteniendo datos: ${error}`);
        if (error == "AxiosError: Request failed with status code 401") {
          navigate("/login")
          alert("Sesión caducada!")
        }
      });
  }

  async function obtenerVAPID() {
    const headers = 'content-type: application/json; charset=utf-8'

    await axios.get(`https://socializeapi.azurewebsites.net/api/getvapid`, null, { headers })
      .then(response => {
        if (response.data !== null) {
          setPublicKey(response.data.keys.publicKey)
          statePublicKey = response.data.keys.publicKey
          setPrivateKey(response.data.keys.privateKey)
          statePrivateKey = response.data.keys.privateKey
        }

      })
      .catch(error => {
        console.log(`Error obteniendo datos: ${error}`);
      });
  }

  function decryptData(encryptedText) {
    // Define la misma clave que usaste en el backend
    const key = "AKeyThatIsAtLeast32CharactersLongForHS256";

    // Decodifica el texto encriptado de base64
    const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedText);

    // Extrae el IV (los primeros 16 bytes) y el contenido encriptado
    const iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, 4), 16);
    const encryptedContent = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(4));

    // Deriva la clave usando SHA256
    const hashedKey = CryptoJS.SHA256(key);

    // Desencripta el contenido
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encryptedContent },
      hashedKey,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    // Convierte el resultado a texto legible
    return decrypted.toString(CryptoJS.enc.Utf8);
  }






  const handleFileChange = (e) => {
    const file = e.target.files[0];
    // if (file && file.type === 'image/png') {
    //   const reader = new FileReader();
    //   reader.onloadend = () => {
    //     setAvatarPreview(reader.result);
    //   };
    //   reader.readAsDataURL(file);
    // }

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setAvatarPreview(reader.result);
      };
      reader.readAsDataURL(file);
      setAvatarPreviewBlob(file)
    }

  };

  const uploadAvatar = async () => {
    if (!avatarPreview) return;

    let compressedFile;
    var imageUrl = "";

    console.log("avatarPreview")
    console.log(avatarPreview)

    const options = {
      maxSizeMB: 1, // Tamaño máximo en MB
      maxWidthOrHeight: 1024, // Resolución máxima
      useWebWorker: true, // Usar Web Worker para mejor rendimiento
      fileType: 'image/webp', // Convertir a WebP
    };

    try {

      compressedFile = await imageCompression(avatarPreviewBlob, options);
      imageUrl = await uploadImageToBackend(compressedFile);
      // formData.append('file', compressedFile);
    } catch (error) {
      console.error('Error comprimiendo la imagen:', error);
    }


    const base64Data = avatarPreview.split(',')[1];

    // Estructura de datos a encriptar
    const userData = {
      id: props.user.id, // Reemplaza con el ID real
      avatar: imageUrl,
      // ... otros campos del usuario
    };

    console.log(userData)

    try {
      const headers = 'content-type: application/json; charset=utf-8'
      const encryptionKey = "EsteEsUnEjemploDeClaveDe32Caracteres!";

      // Encripta los datos (implementa tu lógica de encriptación)

      const jsonData = JSON.stringify(userData);
      const encripted_data = CryptoJS.AES.encrypt(jsonData, encryptionKey).toString();


      await axios.put('https://socializeapi.azurewebsites.net/api/UpdateUser', { data: encripted_data }, { headers })
        .then(response => {
          setAvatarPreview(null)
          getAvatar()
        })
        .catch(error => {
          console.log(`Error obteniendo datos: ${error}`);
        });

    } catch (error) {
      console.log(`Error obteniendo datos: ${error}`);
    } finally {
      setLoading(false); // Ocultar pantalla de carga
    }
  };

  const openEventDetails = (post) => {
    store.dispatch(EVENTDETAILS_action(post))
    // navigate("/eventdetails/" + props.event.eventID)
    navigate("/event/" + post.slug)
    // return <Navigate to="/createevent" />;
  }

  const uploadImageToBackend = async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch('https://socializeapi.azurewebsites.net/api/upload', {
      method: 'POST',
      body: formData,
    });

    console.log("uploadImageToBackend")
    console.log(response)

    if (response.ok) {
      const data = await response.json(); // Obtener la URL de la respuesta
      console.log('Imagen subida con éxito. URL:', data.url);
      return data.url; // Retornar la URL para asociarla al evento
    } else {
      console.error('Error subiendo la imagen');
      throw new Error('Error al subir la imagen')
    }
  };


  const handleAvatarClick = () => {
    fileInputRef.current.click();
  };

  const deleteEvent = (post) => {
    const token = localStorage.getItem('jwt_token');
    const headers = 'content-type: application/json; charset=utf-8'
    console.log(post)
    const data = { data: post.eventID }


    const jsonData = JSON.stringify(data);
    const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

    axios.post('https://socializeapi.azurewebsites.net/api/DeleteEvent', { data: data_encripted }, {
      headers
    })
      .then(response => {
        GetEvents()

      })
      .catch(error => {
        console.log(`Error al intentar eliminar el evento: ${error}`);
      });
  }

  const handleShare = async (e) => {

    console.log(e)


    const encryptedID = CryptoJS.AES.encrypt(e.toString(), "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Invitación',
          text: 'Únete al evento en nuestra página',
          url: `https://hisocialize.netlify.app/registro?data=${encodeURIComponent(encryptedID)}`,
        });
        console.log('Compartido con éxito');
      } catch (error) {
        console.error('Error al compartir:', error);
      }
    } else {
      alert('La función de compartir no está disponible en este dispositivo.');
    }
  };

  useEffect(() => {
    if (!props.token) {
      console.log("el token no es valido")
      navigate("/")
    } else { // consulta si esta suscripto a las notificaciones o no
      getUsers();
      getAvatar();
      GetEvents();

      getFriends();
      getPendingFriends();

      const userAgent = navigator.userAgent;
      const headers = 'content-type: application/json; charset=utf-8'

      const encryptionKey = "EsteEsUnEjemploDeClaveDe32Caracteres!";

      const data = {
        UserID: props.user.id,
        Device: userAgent
      }

      const jsonData = JSON.stringify(data);
      const encripted_data = CryptoJS.AES.encrypt(jsonData, encryptionKey).toString();

      axios.post('https://socializeapi.azurewebsites.net/api/verifysubscription', { data: encripted_data }, { headers })
        .then(response => {
          if (response.data.response == "Existe Suscripcion") {
            setSubscriptedToNotifications(true);
          } else {
            setSubscriptedToNotifications(false);
          }
        })
        .catch(error => {
          console.log(`Error obteniendo datos: ${error}`);
        });
    }
  }, []);

  useEffect(() => {

    setUserName(props.user.nombre)
    setUserPhone(props.user.phone)
    setUserEmail(props.user.email)
    setUserPassword(props.user.password)

    


    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 960); // set the breakpoint here
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Estilos en línea como objetos de JavaScript
  const styles = {
    loadingScreen: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    },
    loadingModal: {
      backgroundColor: 'white',
      padding: '20px 30px',
      borderRadius: '8px',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
      textAlign: 'center',
    },
    loadingSpinner: {
      margin: '20px auto',
      width: '40px',
      height: '40px',
      border: '4px solid transparent',
      borderTop: '4px solid #3498db',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
    },
    '@keyframes spin': {
      from: {
        transform: 'rotate(0deg)',
      },
      to: {
        transform: 'rotate(360deg)',
      },
    },
  };




  // Agregar estilos globales al scrollbar
  const customScrollbarStyles = `
  ::-webkit-scrollbar {
    width: 10px;
  }


  ::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 8px;
  }


  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 8px;
  }


  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      {/* Header */}
      <Header />

      {isLargeScreen && <Sidebar></Sidebar>}

      <Container maxWidth="lg" sx={{ mt: 12, mb: 4, flexGrow: 1 }}>
        <Grid container spacing={3}>
          {/* Perfil Header */}
          <Grid item xs={12}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 2,
                // background: 'linear-gradient(to right, #f5f7fa, #c3cfe2)'
              }}
            >
              <Grid container spacing={3} alignItems="center">
                {/* Avatar y botones de edición */}
                <Grid item xs={12} sm={4} md={3} sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Box sx={{ position: 'relative' }}>
                    <Avatar
                      src={avatarPreview || userAvatar || '/default-avatar.png'}
                      sx={{
                        width: { xs: 120, sm: 150 },
                        height: { xs: 120, sm: 150 },
                        border: '4px solid white',
                        // boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                      }}
                      onClick={allowEdition ? handleAvatarClick : null}
                    />
                    {allowEdition && (
                      <Fab
                        color="primary"
                        aria-label="edit"
                        size="small"
                        onClick={handleAvatarClick}
                        sx={{
                          position: 'absolute',
                          bottom: 0,
                          right: 0,
                          boxShadow: 2
                        }}
                      >
                        <ModeEditIcon fontSize="small" />
                      </Fab>
                    )}
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      style={{ display: 'none' }}
                      accept="image/*"
                    />
                  </Box>
                </Grid>

                {/* Información del perfil */}
                <Grid item xs={12} sm={8} md={9}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, flexWrap: 'wrap' }}>
                      <Typography variant="h4" sx={{ mr: 2, width: !isLargeScreen ? '100%' : null, fontSize: !isLargeScreen && '1rem', mb: !isLargeScreen ? 2 : null }}>
                        {allowEdition ? (
                          <TextField
                            variant="standard"
                            value={userName}
                            onChange={(e) => {
                              setUserName(e.target.value);
                              setChangedValue(true);
                            }}
                            sx={{ fontSize: '1.5rem', fontWeight: 'bold' }}
                          />
                        ) : (
                          userName
                        )}
                      </Typography>

                      {!allowEdition ? (
                        <Button
                          variant="outlined"
                          startIcon={<ModeEditIcon />}
                          onClick={() => setAllowEdition(true)}
                          sx={{ borderRadius: 28, textTransform: 'none' }}
                        >
                          Editar perfil
                        </Button>
                      ) : (
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <Button
                            variant="contained"
                            color="primary"
                            startIcon={<CheckIcon />}
                            onClick={updateProfile}
                            disabled={loading}
                            sx={{ borderRadius: 28, textTransform: 'none' }}
                          >
                            Guardar
                          </Button>
                          <Button
                            variant="outlined"
                            color="error"
                            startIcon={<CloseIcon />}
                            onClick={() => {
                              setAllowEdition(false);
                              setUserName(props.user.nombre);
                              setUserEmail(props.user.email);
                              setUserPhone(props.user.phone);
                              setAvatarPreview(null);
                            }}
                            sx={{ borderRadius: 28, textTransform: 'none' }}
                          >
                            Cancelar
                          </Button>
                        </Box>
                      )}

                      <IconButton
                        color="primary"
                        sx={{ ml: 'auto' }}
                        onClick={() => setOpenModal(true)}
                      >
                        <SettingsIcon />
                      </IconButton>
                    </Box>

                    {/* Estadísticas */}
                    <Box sx={{ display: 'flex', mb: 2, gap: { xs: 2, sm: 4 } }}>
                      <Box sx={{ textAlign: 'center' }}>
                        <Typography variant="h6" fontWeight="bold">{posts.length}</Typography>
                        <Typography variant="body2" color="text.secondary">Eventos</Typography>
                      </Box>
                      <Box sx={{ textAlign: 'center' }}>
                        <Typography variant="h6" fontWeight="bold">{friends.length}</Typography>
                        <Typography variant="body2" color="text.secondary">Amigos</Typography>
                      </Box>
                      <Box sx={{ textAlign: 'center' }}>
                        <div style={{ cursor: 'pointer' }} onClick={() => { setOpenModalPendingFriends(true) }}>
                          <Typography variant="h6" fontWeight="bold">{pendingFriends.length}</Typography>
                          <Typography variant="body2" color="text.secondary">Amigos Pendientes</Typography>
                        </div>
                      </Box>
                    </Box>

                    {/* Bio y detalles */}
                    <Box>
                      {allowEdition ? (
                        <>
                          <TextField
                            fullWidth
                            label="Email"
                            variant="outlined"
                            value={userEmail}
                            onChange={(e) => {
                              setUserEmail(e.target.value);
                              setChangedValue(true);
                            }}
                            size="small"
                            margin="dense"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <ForwardToInboxIcon fontSize="small" />
                                </InputAdornment>
                              ),
                            }}
                          />
                          {/* <TextField
                          fullWidth
                          label="Teléfono"
                          variant="outlined"
                          value={userPhone}
                          onChange={(e) => {
                            setUserPhone(e.target.value);
                            setChangedValue(true);
                          }}
                          size="small"
                          margin="dense"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PhoneAndroidIcon fontSize="small" />
                              </InputAdornment>
                            ),
                          }}
                        /> */}
                        </>
                      ) : (
                        <>
                          <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <ForwardToInboxIcon fontSize="small" sx={{ mr: 1 }} />
                            {userEmail}
                          </Typography>
                          {/* <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center' }}>
                          <PhoneAndroidIcon fontSize="small" sx={{ mr: 1 }} />
                          {userPhone}
                        </Typography> */}
                        </>
                      )}
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Tabs y Contenido */}
          <Grid item xs={12} sx={{mb: 16}}>
            <Paper elevation={0} sx={{ borderRadius: 2 }}>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                centered
                variant="fullWidth"
                sx={{ borderBottom: 1, borderColor: 'divider' }}
              >
                <Tab icon={<GridViewIcon />} label="PUBLICACIONES" />
                <Tab icon={<PeopleOutlineIcon />} label="AMIGOS" />
                {/* <Tab icon={<BookmarkIcon />} label="GUARDADOS" /> */}
              </Tabs>

              {/* Contenido de Publicaciones */}
              {tabValue === 0 && (
                <Box sx={{ p: 3 }}>
                  <Grid container spacing={2}>
                    {posts.map((post, index) => (
                      <Grid item xs={6} sm={4} key={index}>
                        <Box
                          sx={{
                            position: 'relative',
                            paddingTop: '100%', // Aspect ratio 1:1
                            borderRadius: 1,
                            overflow: 'hidden',
                            '&:hover .overlay': {
                              opacity: isLargeScreen ? 1 : 0,
                              pointerEvents: isLargeScreen ? 'auto' : 'none'
                            },
                            '&:active .overlay': {
                              opacity: isLargeScreen ? 1 : 0,
                              pointerEvents: isLargeScreen ? 'auto' : 'none'
                            }
                          }}
                          onClick={(e) => {
                            if (!isLargeScreen) {
                              const overlay = e.currentTarget.querySelector('.overlay');
                              if (overlay) {
                                overlay.style.opacity = '1';
                                overlay.style.pointerEvents = 'auto';
                                // Auto-hide overlay after 2 seconds on mobile
                                setTimeout(() => {
                                  overlay.style.opacity = '0';
                                  overlay.style.pointerEvents = 'none';
                                }, 2000);
                              }
                            }
                          }}
                        >
                          {post.eventImage ? (
                            <Box
                              component="img"
                              src={`${post.eventImage}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}
                              alt={`Post ${post.eventTitle}`}
                              sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                              }}
                            />
                          ) : (
                            <Box
                              sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                background: `linear-gradient(45deg, 
                                  rgb(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}),
                                  rgb(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)})
                                )`,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              <PartyModeIcon sx={{ fontSize: 80, color: 'white', opacity: 0.8 }} />
                            </Box>
                          )}

                          <Box
                            sx={{
                              position: 'absolute',
                              bottom: 0,
                              width: '100%',
                              background: post.eventImage && 'linear-gradient(transparent, rgba(0,0,0,0.9))',
                              padding: 2,
                              color: 'white',
                              boxSizing: 'border-box',
                            }}
                          >
                            <Typography
                              variant={isLargeScreen ? 'h5' : 'h6'}
                              sx={{
                                marginBottom: 1,
                                fontWeight: 600,
                                textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                animation: 'fadeIn 0.5s ease-in',
                                '@keyframes fadeIn': {
                                  from: { opacity: 0, transform: 'translateY(20px)' },
                                  to: { opacity: 1, transform: 'translateY(0)' }
                                }
                              }}
                            >
                              {post.eventTitle}
                            </Typography>

                            <Typography
                              variant="body2"
                              sx={{
                                opacity: 0.9,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                lineHeight: 1.2,
                                fontSize: isLargeScreen ? '0.9rem' : '0.8rem',
                                width: '100%',
                                paddingRight: 1
                              }}
                            >
                              {post.eventDescription}
                            </Typography>
                          </Box>

                          <Box
                            className="overlay"
                            sx={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                              backgroundColor: 'rgba(0,0,0,0.6)',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              opacity: 0,
                              transition: 'opacity 0.3s',
                              pointerEvents: 'none', // Initially disable all pointer events
                              '&[style*="opacity: 1"]': {
                                pointerEvents: 'auto' // Enable pointer events only when visible
                              }
                            }}
                          >
                            <Grid container spacing={2} sx={{ width: '80%', height: '80%' }}>
                              <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <IconButton
                                  sx={{ bgcolor: 'warning.main', color: 'white' }}
                                  onClick={() => {
                                    navigate("/editevent", { eventData: post });
                                    store.dispatch(EVENTDETAILS_action(post));
                                  }}
                                >
                                  <ModeEditIcon />
                                </IconButton>
                              </Grid>
                              <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <IconButton sx={{ bgcolor: 'error.main', color: 'white' }} onClick={(e) => {
                                      e.stopPropagation();
                                      handleDeletePost(post.eventID);
                                    }}>
                                  <DeleteIcon />
                                </IconButton>
                              </Grid>
                              <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <IconButton sx={{ bgcolor: 'info.main', color: 'white' }}
                                  onClick={() => {
                                    // handleShare(post.eventID)
                                    setOpenShareModal(true);
                                    setEventLink(`https://hisocialize.netlify.app/event/${post.slug}`);

                                  }}>
                                  <ShareRoundedIcon />
                                </IconButton>
                              </Grid>
                              <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <IconButton
                                  sx={{ bgcolor: 'success.main', color: 'white' }}
                                  onClick={() => openEventDetails(post)}
                                >
                                  <VisibilityIcon />
                                </IconButton>
                              </Grid>
                            </Grid>
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              )}

              {/* Contenido de Amigos */}
              {tabValue === 1 && (
                <Box sx={{ p: 3 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                    <TextField
                      placeholder="Buscar amigos..."
                      variant="outlined"
                      size="small"
                      value={searchFriends}
                      onChange={(e) => setSearchFriends(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      sx={{ width: '50%' }}
                    />
                    <Button
                      variant="contained"
                      startIcon={isLargeScreen && <GroupAddIcon />}
                      onClick={() => setOpenModalAddFriends(true)}
                      sx={{ borderRadius: 28, textTransform: 'none' }}
                    >
                      Agregar amigos
                    </Button>
                  </Box>

                  {loadingFriends ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                      {filteredFriends.length > 0 ? (
                        filteredFriends.map((friend, index) => {
                          // Create a separate menu anchor element for each friend
                          const menuId = `friend-menu-${friend.userID}`;
                          
                          return (
                            <ListItem
                              key={index}
                              secondaryAction={
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    setAnchorEl({
                                      element: e.currentTarget,
                                      friendId: friend.userID,
                                      menuId: menuId
                                    });
                                    setSelectedFriendList(friend);
                                  }}
                                >
                                  <MoreVertIcon />
                                </IconButton>
                              }
                              disablePadding
                            >
                              <ListItemButton>
                                <ListItemAvatar>
                                  <Avatar
                                    alt={friend.nameUser}
                                    src={`${friend.avatar}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}
                                    sx={{ width: isLargeScreen ? 50 : 36, height: isLargeScreen ? 50 : 36, mr: 1 }}
                                  />
                                </ListItemAvatar>
                                <ListItemText
                                  primary={friend.nameUser}
                                  secondary={friend.email}
                                  primaryTypographyProps={{ fontWeight: 'medium' }}
                                />
                              </ListItemButton>
                              <Menu
                                id={menuId}
                                anchorEl={anchorEl?.menuId === menuId ? anchorEl.element : null}
                                open={Boolean(anchorEl?.menuId === menuId)}
                                onClose={() => setAnchorEl(null)}
                                elevation={2}
                                slotProps={{
                                  paper: {
                                    sx: {
                                      borderRadius: 2,
                                      boxShadow: '0px 2px 8px rgba(0,0,0,0.1)'
                                    }
                                  }
                                }}
                              >
                                <MenuItem
                                  onClick={() => {
                                    setOpenModalConfirmarBlockFriend(true);
                                    setIdUserToBlock(friend.userID);
                                    setAnchorEl(null);
                                  }}
                                >
                                  <ListItemIcon>
                                    <BlockIcon fontSize="small" />
                                  </ListItemIcon>
                                  <ListItemText>Bloquear</ListItemText>
                                </MenuItem>
                                <MenuItem
                                  onClick={() => {
                                    setIdUserToDelete(friend.userID);
                                    setOpenModalConfirmarDeleteFriend(true);
                                    setAnchorEl(null);
                                  }}
                                >
                                  <ListItemIcon>
                                    <PersonRemoveIcon fontSize="small" color="error" />
                                  </ListItemIcon>
                                  <ListItemText>Eliminar amistad</ListItemText>
                                </MenuItem>
                              </Menu>
                            </ListItem>
                          );
                        })
                      ) : (
                        <Box sx={{ textAlign: 'center', py: 3 }}>
                          <Typography variant="body1" color="text.secondary">
                            No se encontraron amigos
                          </Typography>
                          <Button
                            variant="text"
                            startIcon={<GroupAddIcon />}
                            onClick={() => setOpenModalAddFriends(true)}
                            sx={{ mt: 1 }}
                          >
                            Agregar amigos
                          </Button>
                        </Box>
                      )}
                    </List>
                  )}
                </Box>
              )}

              {/* Contenido de Guardados */}
              {tabValue === 2 && (
                <Box sx={{ p: 3, textAlign: 'center' }}>
                  <BookmarkIcon sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
                  <Typography variant="h6">No hay elementos guardados</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Los elementos que guardes aparecerán aquí
                  </Typography>
                </Box>
              )}
            </Paper>
          </Grid>
        </Grid>

        {/* Invoca los Bottones del Bottom */}
        {!isLargeScreen && (
          <>
            <FloatingActionButton />
            <BottomNavigationBar />
          </>
        )}
      </Container>



      {/* Modal de Notificaciones */}
      <Modal
        open={openModal}
        onClose={() => { setOpenModal(false) }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: (isLargeScreen ? 400 : 300),
          bgcolor: 'background.paper',
          // border: '2px solid #000',
          boxShadow: 24,
          p: 4,
          borderRadius: '0.5em'
        }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Actualmente tienes las notificaciones de Google deshabilitadas en este dispositivo, una vez las habilites ya podrás recibir notificaciones en este dispositivo.
          </Typography>

          <Button variant="contained" color='success' onClick={() => { setOpenModal(false) }} style={{ marginTop: 16, width: (isLargeScreen ? 400 : 300), marginBottom: 16 }}>
            OK
          </Button>
        </Box>
      </Modal>

      {/* Modal actualizacion datos usuario */}
      <Modal
        open={openModalUpdatedUser}
        onClose={() => { setOpenModalUpdatedUser(false) }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: (isLargeScreen ? 400 : 300),
          bgcolor: 'background.paper',
          // border: '2px solid #000',
          boxShadow: 24,
          p: 4,
          borderRadius: '0.5em'
        }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Perfil actualizado correctamente!
          </Typography>

          <Button variant="contained" color='success' onClick={() => { setOpenModalUpdatedUser(false) }} style={{ marginTop: 16, width: (isLargeScreen ? 400 : 300) }}>
            OK
          </Button>
        </Box>
      </Modal>

      {/* Modal para agregar amigo */}
      <Modal
        open={openModalAddFriends}
        onClose={() => { setOpenModalAddFriends(false) }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Paper
          elevation={3}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: (isLargeScreen ? 400 : 300),
            bgcolor: 'background.paper',
            borderRadius: 3,
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3
          }}
        >
          <Typography
            variant="h5"
            color="primary"
            fontWeight="500"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            <GroupAddIcon />
            Añadir amigo
          </Typography>

          <Autocomplete
            fullWidth
            size='medium'
            options={availableUsers}
            getOptionLabel={(option) => option.NameUser}
            onChange={selectedFriend}
            filterOptions={(options, { inputValue }) => {
              if (inputValue.length > 0) {
                return options.filter(option =>
                  option.NameUser.toLowerCase().includes(inputValue.toLowerCase())
                );
              }
              return [];
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder='Buscar usuario'
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  )
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    '&:hover fieldset': {
                      borderColor: 'primary.main',
                    }
                  }
                }}
              />
            )}
            sx={{
              '& .MuiAutocomplete-input': {
                padding: '12px 8px !important'
              }
            }}
          />

          <Stack
            direction="row"
            spacing={2}
            width="100%"
            justifyContent="center"
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<SendIcon />}
              onClick={() => {
                setOpenModalAddFriends(false);
                sendFriendshipRequest();
              }}
              sx={{
                borderRadius: 2,
                py: 1.5,
                flex: 2,
                textTransform: 'none',
                fontWeight: 500
              }}
            >
              Enviar solicitud
            </Button>

            <Button
              variant="outlined"
              color="error"
              startIcon={<CloseIcon />}
              onClick={() => { setOpenModalAddFriends(false) }}
              sx={{
                borderRadius: 2,
                py: 1.5,
                flex: 1,
                textTransform: 'none',
                fontWeight: 500
              }}
            >
              Cancelar
            </Button>
          </Stack>
        </Paper>
      </Modal>

      {/* Modal lista amigos pendientes */}
      {/* Modal de confirmación para eliminar post */}
      <Modal
        open={openModalConfirmarDeletePost}
        onClose={() => {
          setOpenModalConfirmarDeletePost(false);
          setPostToDelete(null);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Paper
          elevation={3}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: (isLargeScreen ? 400 : '90%'),
            maxWidth: 500,
            bgcolor: 'background.paper',
            borderRadius: 3,
            p: 3,
            display: 'flex',
            flexDirection: 'column',
            gap: 2
          }}
        >
          <Typography variant="h6" component="h2" sx={{ textAlign: 'center' }}>
            ¿Estás seguro que deseas eliminar este evento?
          </Typography>
          <Typography sx={{ textAlign: 'center', color: 'text.secondary' }}>
            Esta acción no se puede deshacer.
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
            <Button
              variant="outlined"
              onClick={() => {
                setOpenModalConfirmarDeletePost(false);
                setPostToDelete(null);
              }}
              startIcon={<CancelIcon />}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={confirmDeletePost}
              startIcon={<DeleteIcon />}
            >
              Eliminar
            </Button>
          </Stack>
        </Paper>
      </Modal>

      <Modal
        open={openModalPendingFriends}
        onClose={() => { setOpenModalPendingFriends(false) }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Paper
          elevation={3}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: (isLargeScreen ? 400 : '90%'),
            maxWidth: 500,
            bgcolor: 'background.paper',
            borderRadius: 3,
            p: 3,
            display: 'flex',
            flexDirection: 'column',
            gap: 2
          }}
        >
          <Box sx={{ textAlign: 'center', mb: 2 }}>
            <Typography
              variant="h5"
              color="primary"
              fontWeight="500"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1
              }}
            >
              <MoreTimeIcon />
              Solicitudes pendientes
            </Typography>
          </Box>

          {loadingPendingFriends ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
              <CircularProgress />
            </Box>
          ) : (
            <Box
              sx={{
                maxHeight: '50vh',
                overflowY: 'auto',
                '&::-webkit-scrollbar': {
                  width: '8px'
                },
                '&::-webkit-scrollbar-track': {
                  bgcolor: 'grey.100',
                  borderRadius: '4px'
                },
                '&::-webkit-scrollbar-thumb': {
                  bgcolor: 'grey.400',
                  borderRadius: '4px',
                  '&:hover': {
                    bgcolor: 'grey.500'
                  }
                }
              }}
            >
              {pendingFriends.length > 0 ? (
                <List>
                  {pendingFriends.map((item, index) => (
                    <React.Fragment key={index}>
                      <ListItem
                        sx={{
                          py: 1.5,
                          px: 2,
                          transition: 'background-color 0.2s',
                          '&:hover': {
                            bgcolor: 'grey.50'
                          }
                        }}
                      >
                        <ListItemAvatar>
                          <Avatar
                            alt={item.nameUser}
                            src={`${item.avatar}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}
                            sx={{ width: 45, height: 45 }}
                          />
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <Typography
                              variant="subtitle1"
                              fontWeight="500"
                              sx={{
                                fontSize: isLargeScreen ? 16 : 14
                              }}
                            >
                              {item.nameUser}
                            </Typography>
                          }
                        />
                        <Stack direction="row" spacing={1}>
                          <Tooltip title="Aceptar solicitud">
                            <IconButton
                              color="primary"
                              onClick={() => addFriend(item.userID)}
                              sx={{
                                '&:hover': {
                                  bgcolor: 'primary.light',
                                  transform: 'scale(1.1)'
                                }
                              }}
                            >
                              <CheckIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Rechazar solicitud">
                            <IconButton
                              color="error"
                              onClick={() => cancelFriend(item.userID)}
                              sx={{
                                '&:hover': {
                                  bgcolor: 'error.light',
                                  transform: 'scale(1.1)'
                                }
                              }}
                            >
                              <CloseIcon />
                            </IconButton>
                          </Tooltip>
                        </Stack>
                      </ListItem>
                      <Divider />
                    </React.Fragment>
                  ))}
                </List>
              ) : (
                <Box
                  sx={{
                    p: 4,
                    textAlign: 'center',
                    color: 'text.secondary'
                  }}
                >
                  <Typography variant="h6" gutterBottom>
                    No tienes solicitudes pendientes
                  </Typography>
                  <Typography variant="body2">
                    Las solicitudes de amistad aparecerán aquí
                  </Typography>
                </Box>
              )}
            </Box>
          )}

          <Button
            variant="outlined"
            color="primary"
            onClick={() => setOpenModalPendingFriends(false)}
            sx={{
              mt: 2,
              borderRadius: 3,
              textTransform: 'none',
              fontWeight: 500
            }}
          >
            Cerrar
          </Button>
        </Paper>
      </Modal>

      {/* Modal lista usuarios bloqueados */}
      <Modal
        open={openModalBlockedUsers}
        onClose={() => { setOpenModalBlockedUsers(false) }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Paper
          elevation={3}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: (isLargeScreen ? 400 : '90%'),
            maxWidth: 500,
            bgcolor: 'background.paper',
            borderRadius: 3,
            p: 3,
            display: 'flex',
            flexDirection: 'column',
            gap: 2
          }}
        >
          <Box sx={{ textAlign: 'center', mb: 2 }}>
            <Typography
              variant="h5"
              color="primary"
              fontWeight="500"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1
              }}
            >
              <NoAccountsIcon />
              Usuarios bloqueados
            </Typography>
          </Box>

          {loadingBlockedFriends ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
              <CircularProgress />
            </Box>
          ) : (
            <Box
              sx={{
                maxHeight: '50vh',
                overflowY: 'auto',
                '&::-webkit-scrollbar': {
                  width: '8px'
                },
                '&::-webkit-scrollbar-track': {
                  bgcolor: 'grey.100',
                  borderRadius: '4px'
                },
                '&::-webkit-scrollbar-thumb': {
                  bgcolor: 'grey.400',
                  borderRadius: '4px',
                  '&:hover': {
                    bgcolor: 'grey.500'
                  }
                }
              }}
            >
              {blockedFriends.length > 0 ? (
                <List>
                  {blockedFriends.map((item, index) => (
                    <React.Fragment key={index}>
                      <ListItem
                        sx={{
                          py: 1.5,
                          px: 2,
                          transition: 'background-color 0.2s',
                          '&:hover': {
                            bgcolor: 'grey.50'
                          }
                        }}
                      >
                        <ListItemAvatar>
                          <Avatar
                            alt={item.nameUser}
                            src={`${item.avatar}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}
                            sx={{ width: 45, height: 45 }}
                          />
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <Typography
                              variant="subtitle1"
                              fontWeight="500"
                              sx={{
                                fontSize: isLargeScreen ? 16 : 14
                              }}
                            >
                              {item.nameUser}
                            </Typography>
                          }
                        />
                        <Tooltip title="Desbloquear usuario">
                          <IconButton
                            onClick={() => undoBlockedUser(item.userID)}
                            sx={{
                              color: 'info.main',
                              '&:hover': {
                                bgcolor: 'info.light',
                                transform: 'scale(1.1)'
                              },
                              transition: 'all 0.2s'
                            }}
                          >
                            <UndoIcon />
                          </IconButton>
                        </Tooltip>
                      </ListItem>
                      <Divider />
                    </React.Fragment>
                  ))}
                </List>
              ) : (
                <Box
                  sx={{
                    p: 4,
                    textAlign: 'center',
                    color: 'text.secondary'
                  }}
                >
                  <Typography variant="h6" gutterBottom>
                    No hay usuarios bloqueados
                  </Typography>
                  <Typography variant="body2">
                    Los usuarios que bloquees aparecerán aquí
                  </Typography>
                </Box>
              )}
            </Box>
          )}

          <Button
            variant="outlined"
            color="primary"
            onClick={() => setOpenModalBlockedUsers(false)}
            sx={{
              mt: 2,
              borderRadius: 3,
              textTransform: 'none',
              fontWeight: 500
            }}
          >
            Cerrar
          </Button>
        </Paper>
      </Modal>


      {/* Modal borrar cuenta */}
      <Modal
        open={openModalConfirmarDelete}
        onClose={() => { setOpenModalConfirmarDelete(false) }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Paper
          elevation={24}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: (isLargeScreen ? 400 : 300),
            bgcolor: 'background.paper',
            p: 4,
            borderRadius: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2
          }}
        >
          <Box sx={{ mb: 2, textAlign: 'center' }}>
            <Typography
              color="error"
              variant="h4"
              fontWeight="500"
              gutterBottom
            >
              Borrar mi cuenta
            </Typography>
          </Box>

          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              ¿Está seguro que desea eliminar su cuenta?
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
            >
              Si es así, confirme su contraseña
            </Typography>
          </Box>

          <TextField
            fullWidth
            type="password"
            variant="outlined"
            placeholder="Ingrese su contraseña"
            value={passwordConfirmation}
            onChange={(event) => setPasswordConfirmation(event.target.value)}
            error={!!msgError}
            helperText={msgError}
            sx={{
              mb: 4,
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                textAlign: 'center'
              }
            }}
          />

          <Stack
            direction="row"
            spacing={2}
            width="100%"
          >
            <Button
              fullWidth
              variant="contained"
              color="error"
              onClick={deleteUser}
              startIcon={<DeleteIcon />}
              sx={{
                borderRadius: 3,
                py: 1.5,
                textTransform: 'none',
                fontWeight: 500
              }}
            >
              Eliminar mi cuenta
            </Button>

            <Button
              fullWidth
              variant="outlined"
              onClick={() => setOpenModalConfirmarDelete(false)}
              startIcon={<CancelIcon />}
              sx={{
                borderRadius: 3,
                py: 1.5,
                textTransform: 'none',
                fontWeight: 500
              }}
            >
              Cancelar
            </Button>
          </Stack>
        </Paper>
      </Modal>

      {/* Modal eliminar amigo */}
      <Modal
        open={openModalConfirmarDeleteFriend}
        onClose={() => { setOpenModalConfirmarDeleteFriend(false) }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: (isLargeScreen ? 400 : 300),
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 3
        }}>
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2
          }}>
            <Avatar sx={{
              bgcolor: 'error.light',
              width: 56,
              height: 56
            }}>
              <PersonRemoveIcon sx={{ fontSize: 32 }} />
            </Avatar>

            <Typography
              variant="h6"
              sx={{
                color: 'text.secondary',
                textAlign: 'center',
                fontWeight: 500
              }}
            >
              ¿Estás seguro que quieres eliminar esta amistad?
            </Typography>
          </Box>

          <Box sx={{
            display: 'flex',
            gap: 2,
            justifyContent: 'center'
          }}>
            <Button
              variant="contained"
              color="error"
              onClick={() => { cancelFriend(idUserToDelete) }}
              sx={{
                flex: 1,
                py: 1.5
              }}
            >
              Confirmar
            </Button>

            <Button
              variant="outlined"
              onClick={() => { setOpenModalConfirmarDeleteFriend(false) }}
              sx={{
                flex: 1,
                py: 1.5
              }}
            >
              Cancelar
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Modal bloquear amigo */}
      <Modal
        open={openModalConfirmarBlockFriend}
        onClose={() => { setOpenModalConfirmarBlockFriend(false) }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: (isLargeScreen ? 400 : 300),
          bgcolor: 'background.paper',
          // border: '2px solid #000',
          boxShadow: 24,
          p: 4,
          borderRadius: '0.5em'
        }}>
          <Typography id="modal-modal-title" variant="h6" style={{ color: 'grey', textAlign: 'center' }}>
            Estas seguro que quieres bloquear a este usuario?
          </Typography>


          <div style={{ display: 'flex', gap: 16, marginTop: 16 }}>
            <Button variant="contained" color='error' onClick={procesoDeBloqueo} style={{ marginTop: 16, width: (isLargeScreen ? 400 : 300) }}>
              Confirmar
            </Button>

            <Button variant="outlined" color='warning' onClick={() => { setOpenModalConfirmarBlockFriend(false) }} style={{ marginTop: 16, width: (isLargeScreen ? 400 : 300) }}>
              Cancelar
            </Button>
          </div>


        </Box>
      </Modal>

      {/* Modal cancelar amistad */}
      <Modal
        open={openModalConfirmarCancelFriend}
        onClose={() => { setOpenModalConfirmarCancelFriend(false) }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: (isLargeScreen ? 400 : 300),
          bgcolor: 'background.paper',
          // border: '2px solid #000',
          boxShadow: 24,
          p: 4,
          borderRadius: '0.5em'
        }}>
          <Typography id="modal-modal-title" variant="h6" style={{ color: 'grey', textAlign: 'center' }}>
            Estas seguro que quieres eliminar esta amistad?
          </Typography>


          <div style={{ display: 'flex', gap: 16, marginTop: 16 }}>
            <Button variant="contained" color='error' onClick={() => { cancelFriend(idFriendToCancel) }} style={{ marginTop: 16, width: (isLargeScreen ? 400 : 300) }}>
              Confirmar
            </Button>

            <Button variant="outlined" color='warning' onClick={() => { setOpenModalConfirmarCancelFriend(false) }} style={{ marginTop: 16, width: (isLargeScreen ? 400 : 300) }}>
              Cancelar
            </Button>
          </div>


        </Box>
      </Modal>

      {/* Modal de Configuración */}
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: 400 },
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}>
          <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
            Configuración
          </Typography>

          <List>
            <ListItem disablePadding>
              <ListItemButton onClick={() => suscriptionState(subscriptedToNotifications ? "desactivar" : "activar")}>
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: subscriptedToNotifications ? 'success.main' : 'primary.main' }}>
                    <NotificationsActiveIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={subscriptedToNotifications ? "Desactivar notificaciones" : "Activar notificaciones"}
                  secondary="Recibe alertas de actividad"
                />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton onClick={() => {getPendingFriends(); setOpenModalPendingFriends(true)}}>
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: 'warning.main' }}>
                    <MoreTimeIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="Solicitudes pendientes"
                  secondary={`${pendingFriends.length} solicitudes`}
                />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton onClick={() => { getBlockedFriends(); setOpenModalBlockedUsers(true) }}>
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: 'error.light' }}>
                    <BlockIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="Usuarios bloqueados"
                  secondary="Gestionar lista de bloqueos"
                />
              </ListItemButton>
            </ListItem>

            <Divider sx={{ my: 1 }} />

            <ListItem disablePadding>
              <ListItemButton onClick={() => setOpenModalConfirmarDelete(true)}>
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: 'error.main' }}>
                    <DeleteIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="Eliminar cuenta"
                  secondary="Esta acción no se puede deshacer"
                />
              </ListItemButton>
            </ListItem>
          </List>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Button
              variant="outlined"
              onClick={() => setOpenModal(false)}
              startIcon={<CloseIcon />}
            >
              Cerrar
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={openShareModal}
        onClose={() => { setOpenShareModal(false); navigate('/'); }}
        aria-labelledby="share-modal-title"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: isLargeScreen ? 400 : 350,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" component="h2">
              Enviar invitación
            </Typography>
            <IconButton
              size="small"
              onClick={() => { setOpenShareModal(false); }}
              sx={{ ml: 2 }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Typography variant="body1" sx={{ mt: 2 }}>
            Puedes invitar personas compartiendo este enlace:
          </Typography>
          <TextField
            fullWidth
            value={eventLink}
            variant="outlined"
            margin="normal"
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => navigator.clipboard.writeText(eventLink)}>
                    <ContentCopyIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
            <Button
              startIcon={<WhatsAppIcon />}
              variant="contained"
              color="success"
              onClick={() => window.open(`whatsapp://send?text=${encodeURIComponent(`¡Te invito a mi evento! ${eventLink}`)}`)}
            >
              WhatsApp
            </Button>
            <Button
              startIcon={<EmailIcon />}
              variant="contained"
              color="primary"
              onClick={() => window.open(`mailto:?subject=Invitación a evento&body=${encodeURIComponent(`¡Te invito a mi evento! ${eventLink}`)}`)}
            >
              Email
            </Button>
            <Button
              startIcon={<ShareIcon />}
              variant="contained"
              onClick={() => navigator.share({
                title: 'Invitación a evento',
                text: '¡Te invito a mi evento!',
                url: eventLink
              })}
            >
              Compartir
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );


}

export default connect(mapStateToProps)(Perfil)